import supportsRegExLookbehind from "../utils/regex-support-check";
//var regexLookBehindSupport = supportsRegExLookbehind();

var fontSubsets = () => {
  const bannerHeadings = document.querySelectorAll(".hero-section h1 span, .hero-section .h1 span, .inchcape-title");

  if (!bannerHeadings) {
    return;
  }

  bannerHeadings.forEach((heading) => {


    heading.innerHTML = heading.innerHTML.replace(
      /[v]/g,
      '<i>v</i>'
    );
    // careful we dont also replace the 'a' inside 'class' or ambersands
    //TODO: negative lookbehinds will not work in IE11 or any Safari
    //heading.innerHTML = heading.innerHTML.replace(
    //  /(?<!l|&)[a]/g,
    //  '<i class="ss ss1">a</i>'
    //);

    heading.innerHTML = heading.innerHTML.replace(
      /[a]/g,
      '<b>a</b>'
    );

    heading.innerHTML = heading.innerHTML.replace(
      /[m]/g,
      '<b>m</b>'
    );

    heading.innerHTML = heading.innerHTML.replace(
      /[w]/g,
      '<i>w</i>'
    );

    heading.innerHTML = heading.innerHTML.replace(
      /[t]{2}/g,
      '<u>tt</u>'
    );

    // Ambersands are causing some minor headaches. A temporary workaround for this is to change the ambersand to a '+'
    // in the CMS then regex replace the '+' back to an ambersand. This is because we cant use negative lookbehinds in Safari.
    heading.innerHTML = heading.innerHTML.replace(
      /[+]/g,
      ' & '
    );

  });
};
fontSubsets();
